import React from "react";
import SpeedIndicator from "./components/SpeedIndicator";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="app-header">
        <h1>PA-28 Airspeed Indicator</h1>
        <p>Live GPS-based analog airspeed gauge</p>
      </header>
      <main>
        <SpeedIndicator />
      </main>
      <footer className="app-footer">
        <p>⚠️ For reference only - Not for actual flight navigation</p>
        <p>📱 iPhone users: Enable location services in Safari settings</p>
        <p>🔒 Requires HTTPS for GPS functionality</p>
      </footer>
    </div>
  );
}

export default App;
